var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "note_wrap" }, [
    _c("div", {
      staticClass: "menu-toggle",
      class: { "menu-open": !_vm.menuFlag },
      on: { click: _vm.toggleMenu }
    }),
    _vm._v(" "),
    _vm.menuFlag
      ? _c("div", { staticClass: "note_left" }, [
          _c(
            "div",
            {
              staticClass: "top_title",
              on: {
                click: function($event) {
                  return _vm.allNote($event)
                }
              }
            },
            [
              _c("img", {
                attrs: {
                  src: require("../../../../../../static/images/study/icon/zhangjie_all.png")
                }
              }),
              _vm._v(" "),
              _c("h3", [_vm._v("全部章节")])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "catalog_tree" },
            [
              _c("el-tree", {
                attrs: {
                  data: _vm.catalogData,
                  props: _vm.defaultProps,
                  "node-key": "id",
                  "highlight-current": true,
                  indent: 16
                },
                on: { "node-click": _vm.handleNodeClick },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(ref) {
                        var node = ref.node
                        return _c("span", { staticClass: "span-ellipsis" }, [
                          _c("span", { attrs: { title: node.label } }, [
                            _vm._v(_vm._s(node.label))
                          ])
                        ])
                      }
                    }
                  ],
                  null,
                  false,
                  2980223913
                )
              })
            ],
            1
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "note_right" },
      [
        _vm.noteFlag
          ? _c(
              "el-tabs",
              {
                on: { "tab-click": _vm.handleClick },
                model: {
                  value: _vm.activeName,
                  callback: function($$v) {
                    _vm.activeName = $$v
                  },
                  expression: "activeName"
                }
              },
              [
                _c(
                  "el-tab-pane",
                  { attrs: { label: "我的笔记", name: "first" } },
                  [
                    _vm.btnFlag && !_vm.editorNote
                      ? _c("mynote", {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.loading,
                              expression: "loading"
                            }
                          ],
                          ref: "mynote",
                          on: {
                            backNote: _vm.backNote,
                            editorNoteOpen: _vm.editorNoteOpen
                          }
                        })
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-tab-pane",
                  { attrs: { label: "同学笔记", name: "second" } },
                  [
                    _vm.btnFlag && !_vm.editorNote
                      ? _c("classnote", {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.loading,
                              expression: "loading"
                            }
                          ],
                          ref: "classnote",
                          on: {
                            backNote: _vm.backNote,
                            editorNoteOpen: _vm.editorNoteOpen
                          }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.btnFlag && !_vm.editorNote
          ? _c(
              "a",
              {
                staticClass: "btn",
                on: {
                  click: function($event) {
                    return _vm.addNote()
                  }
                }
              },
              [_vm._v("添加笔记")]
            )
          : _vm._e(),
        _vm._v(" "),
        !_vm.btnFlag || _vm.editorNote
          ? _c(
              "a",
              {
                staticClass: "btn_back",
                on: {
                  click: function($event) {
                    return _vm.backNote()
                  }
                }
              },
              [_vm._v("返回")]
            )
          : _vm._e(),
        _vm._v(" "),
        !_vm.noteFlag
          ? _c("span", { staticClass: "note_text" }, [
              _vm._v(_vm._s(_vm.noteText))
            ])
          : _vm._e(),
        _vm._v(" "),
        !_vm.noteFlag ? _c("el-divider") : _vm._e(),
        _vm._v(" "),
        !_vm.btnFlag && !_vm.editorNote
          ? _c("addnote", {
              attrs: { "catalog-id": _vm.catalogId },
              on: { backNote: _vm.backNote }
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.btnFlag && _vm.editorNote
          ? _c("editornote", { on: { backNote: _vm.backNote } })
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6b0c9056", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b0c9056","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/studyCenter/switch/note/note.vue
// module id = null
// module chunks = 